import App from "app";
import dataVisualizations from "core/services/metadataService/dataVisualizations";
import "./editor";
import xss from 'xss';

const options = {
    whiteList: {
        a: ['href', 'title', 'target', 'style', 'class'],
        img: ['style' ,'src', 'alt', 'title', 'width', 'height', 'class'],
        div: ['class', 'style'],
        span: ['class', 'style'],
    }
};

App.module("Dashboard.VisEditor", function (VisEditor, App, Backbone, Marionette, $, _) {
    VisEditor[dataVisualizations.EDITOR.STRING] = VisEditor.Editor.LayoutView.extend({
        templateHTML:
            '<input type="text" name="{{ editor.attribute }}" placeholder="{{ editor.options ? editor.options.placeholder : ""}}"/>',
        events: {
            "change input": "valueChanged",
        },
        valueChanged: function (e) {
            this.on_change(xss(e.target.value, options));
        },
        onRender: function () {
            if (this.model.editor.options.length) {
                this.$("input").css("width", this.model.editor.options.length * 15 + 30);
            }
            this.$("input").val(xss(this.get_value(), options));
        },
    });
});
